<template>
    <div class="borderelement my-4 p-2 md:p-4 bg-transparent-white md:-ml-12 md:-mr-12">
        <div class="text-sm md:ml-6 p-4 md:p-0">
            {{articleItem.maps_strasse}}<br />
            {{articleItem.maps_stadt}}
        </div>
        <div class="p-2 md:p-6">
            <!--TravelMap class="travel-map" :articleItem="articleItem"/-->
            <iframe class="maps" :src="url"></iframe>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'TheMaps',
        components: {

        },
        data() {
            return {
                url: ''
            }
        },
        props: {
            articleItem: {
                type: Object,
                default: () => {}
            }
        },
        created: function() {
            this.url = 'https://api.pgsi2020.de/api/maps/' + this.articleItem.lat + '/' + this.articleItem.long;
        }
    }
</script>


<style lang="scss" scoped>
    .travel-map {
        height: 400px;
    }


    .borderelement{
        position: relative;
        &:before,
        &:after{
            content: '';
            width: 8px;
            height: 40px;
            position: absolute;
        }
        &:before{
            background-color: #c93c26;
            left: 0;
            top: 0;
        }
        &:after{
            background-color: #47ab4c;
            right: 0px;
            bottom: 0;
        }
    }

    .maps{
        height: 400px;
        width: 100%;
    }

</style>

